module.exports = __webpack_public_path__ + "static/don15-4ab3c1f3c65db289d41a9d68d4f46799.jpg";